<template>
  <div>
    <section ref="raiz" class="lluvia-sobres">
      <!-- Elementos decorativos laterales (Flores y Ramas) -->
      <div class="decoracion-lateral decoracion-izq">
        <img :src="floresPng" alt="Flores Izquierda" class="flor-decorativa a-animar-flor-izq" />
        <img :src="ramasPng" alt="Ramas Izquierda" class="rama-decorativa a-animar-rama-izq" />
      </div>
      <div class="decoracion-lateral decoracion-der">
        <img :src="floresPng" alt="Flores Derecha" class="flor-decorativa a-animar-flor-der" />
        <img :src="ramasPng" alt="Ramas Derecha" class="rama-decorativa a-animar-rama-der" />
      </div>

      <div class="contenido">
        <!-- Título principal -->
        <h2 ref="tituloRef" class="titulo a-animar">
          <span class="serif">Gift<br /> Registry</span><br />
          <span class="script"></span>
        </h2>

        <!-- Texto de introducción -->
        <p ref="textoRef" class="texto a-animar">
          Your presence is the most valuable gift to me. ✨  
          But if you wish to give a token, I will receive it with much appreciation   
          and deep gratitude. 
          <br><br>
        </p>

        <!-- SEPARADOR BONITO -->
        <div class="separador a-animar">
          <span class="linea"></span>
          <span class="rombo">♦</span>
          <span class="linea"></span>
        </div>

        <!-- OPCIONES DE REGALO CON ANIMACIÓN CONSECUTIVA -->
        <div class="opciones-regalo">
          <!-- Opción 1: Sobre -->
          <div class="opcion-card a-animar">
            <img :src="sobrePng" alt="Envelope" class="icono-opcion" />
            <h3>Envelope Shower</h3>
            <p>"The envelope shower is the tradition of gifting cash on the day of the event."</p>
          </div>

          <!-- Separador entre opción 1 y 2 -->
          <div class="separador a-animar">
            <span class="linea"></span>
            <span class="rombo">♦</span>
            <span class="linea"></span>
          </div>

          <!-- Opción 2: Gift Card -->
          <div class="opcion-card a-animar">
            <h3>Gift Card</h3>
          </div>

          <!-- Separador entre opción 2 y 3 -->
          <div class="separador a-animar">
            <span class="linea"></span>
            <span class="rombo">♦</span>
            <span class="linea"></span>
          </div>

          <!-- Opción 3: Zelle -->
          <div class="opcion-card a-animar">
            <h3>Zelle</h3>
            <p class="destinatario">Rosalie Torres</p>
            <p class="detalle-zelle">rtorres02011@gmail.com</p>
          </div>
        </div>

        <!-- Separador final antes del Gracias -->
        <div class="separador a-animar">
          <span class="linea"></span>
          <span class="rombo">♦</span>
          <span class="linea"></span>
        </div>

        <p ref="graciasRef" class="gracias a-animar">THANK YOU!</p>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der"></div>
    </section>

    <section ref="raizNinos" class="lluvia-sobres">
      <!-- Elementos decorativos laterales para Niños (Flores y Ramas) -->
      <div class="decoracion-lateral decoracion-izq">
        <img :src="floresPng" alt="Flores Izquierda" class="flor-decorativa a-animar-flor-ninos-izq" />
        <img :src="ramasPng" alt="Ramas Izquierda" class="rama-decorativa a-animar-rama-ninos-izq" />
      </div>
      <div class="decoracion-lateral decoracion-der">
        <img :src="floresPng" alt="Flores Derecha" class="flor-decorativa a-animar-flor-ninos-der" />
        <img :src="ramasPng" alt="Ramas Derecha" class="rama-decorativa a-animar-rama-ninos-der" />
      </div>

      <div class="contenido">
        <!-- Foto que abarca todo el ancho con animación de entrada -->
        <img :src="fotoWebp" alt="Kids Welcome" class="foto-completa a-animar-ninos" />

        <h2 ref="tituloNinosRef" class="titulo a-animar-ninos">
          <span class="serif"> Kids Are Welcome!</span>
        </h2>

        <p ref="textoNinosRef" class="texto a-animar-ninos">
        We’re happy to welcome your little ones as well. To ensure the celebration is a success, we kindly ask that they remain close to you at all times. Specially during the presentation.
        </p>
      </div>

      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>

      <div class="rasgado rasgado-inferior"></div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'
import floresPng from '@/assets/f.png'
import ramasPng from '@/assets/ramas.png'
import fotoWebp from '@/assets/regal.webp'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    let stInstance = null
    let stInstanceNinos = null

    const crearLluvia = (contenedorEl, lado, cantidad) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)

        gsap.fromTo(
          el,
          { xPercent: lado === 'der' ? 110 : -10, yPercent: -10, opacity: 0 },
          {
            xPercent: lado === 'der' ? -20 : 120,
            yPercent: 140,
            opacity: 0.9,
            duration: 2.2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      // --- ANIMACIÓN SECCIÓN 1 (GIFT REGISTRY) ---
      const elementosAAnimar = raiz.value.querySelectorAll('.a-animar')
      const florIzq = raiz.value.querySelector('.a-animar-flor-izq')
      const florDer = raiz.value.querySelector('.a-animar-flor-der')
      const ramaIzq = raiz.value.querySelector('.a-animar-rama-izq')
      const ramaDer = raiz.value.querySelector('.a-animar-rama-der')

      gsap.set(elementosAAnimar, { opacity: 0, y: 35 })
      gsap.set([florIzq, florDer], { opacity: 0, scale: 0.7, rotation: (i) => i === 0 ? -15 : 15 })
      gsap.set([ramaIzq, ramaDer], { opacity: 0, y: -50, scaleY: 0.8 })

      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 80%',
        once: true,
        onEnter: () => {
          crearLluvia(lluviaDer.value, 'der', 10)
          crearLluvia(lluviaIzq.value, 'izq', 10)

          const tlDecoracion = gsap.timeline()
          tlDecoracion
            .to([florIzq, florDer], {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 1.4,
              ease: 'power2.out'
            })
            .to([ramaIzq, ramaDer], {
              opacity: 1,
              y: 0,
              scaleY: 1,
              duration: 1.6,
              ease: 'power3.out'
            }, '-=0.8')

          gsap.to(elementosAAnimar, { 
            opacity: 1, 
            y: 0, 
            duration: 1.2, 
            stagger: 0.15, 
            ease: 'power3.out' 
          })
        }
      })

      // --- ANIMACIÓN SECCIÓN 2 (KIDS WELCOME) ---
      const elementosNinosAAnimar = raizNinos.value.querySelectorAll('.a-animar-ninos')
      const florNinosIzq = raizNinos.value.querySelector('.a-animar-flor-ninos-izq')
      const florNinosDer = raizNinos.value.querySelector('.a-animar-flor-ninos-der')
      const ramaNinosIzq = raizNinos.value.querySelector('.a-animar-rama-ninos-izq')
      const ramaNinosDer = raizNinos.value.querySelector('.a-animar-rama-ninos-der')

      gsap.set(elementosNinosAAnimar, { opacity: 0, y: 35 })
      gsap.set([florNinosIzq, florNinosDer], { opacity: 0, scale: 0.7, rotation: (i) => i === 0 ? -15 : 15 })
      gsap.set([ramaNinosIzq, ramaNinosDer], { opacity: 0, y: -50, scaleY: 0.8 })

      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          crearLluvia(lluviaNinosDer.value, 'der', 10)
          crearLluvia(lluviaNinosIzq.value, 'izq', 10)

          const tlDecoracionNinos = gsap.timeline()
          tlDecoracionNinos
            .to([florNinosIzq, florNinosDer], {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 1.4,
              ease: 'power2.out'
            })
            .to([ramaNinosIzq, ramaNinosDer], {
              opacity: 1,
              y: 0,
              scaleY: 1,
              duration: 1.6,
              ease: 'power3.out'
            }, '-=0.8')

          gsap.to(elementosNinosAAnimar, { 
            opacity: 1, 
            y: 0, 
            duration: 1.2, 
            stagger: 0.15, 
            ease: 'power3.out' 
          })
        }
      })
    })

    onUnmounted(() => {
      stInstance?.kill()
      stInstanceNinos?.kill()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      graciasRef,
      
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
    
      sobrePng,
      floresPng,
      ramasPng,
      fotoWebp
    }
  }
}
</script>

<style scoped>
/* CONTENEDOR */
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #e793b6;
  overflow: hidden;
}

/* DECORACIÓN LATERAL */
.decoracion-lateral {
  position: absolute;
  top: 10px;
  width: 90px;
  z-index: 3; /* Por encima de la lluvia de sobres */
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

.decoracion-izq {
  left: -15px;
}

.decoracion-der {
  right: -15px;
  transform: scaleX(-1); /* Espeja los assets en el lado derecho para simetría */
}

.flor-decorativa {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 4;
  margin-top:-45px;
}

.rama-decorativa {
  width: 75%;
  height: auto;
  margin-top: -42px; /* Ajuste para que se solape y parezca que sale de debajo de las flores */
  transform-origin: top center;
  z-index: 2;
}

/* CONTENIDO */
.contenido{
  position: relative;
  z-index: 2;
}

/* FOTO COMPLETA (NUEVA) */
.foto-completa {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
  margin-bottom: 24px;
  object-fit: cover;
}

/* TITULO */
.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}

.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  opacity: .95;
}

/* TEXTO */
.texto{
  font-family: 'quote', serif;
  font-size: 17px;
  line-height: 1.5;
  color: #fff;
  max-width: 420px;
  margin: 12px auto 18px;
}

/* SEPARADOR BONITO CORREGIDO */
.separador {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 24px auto;
  max-width: 250px;
  width: 100%;
}

.separador .linea {
  flex: 1;
  display: inline-block;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.6);
}

.separador .rombo {
  color: #fff;
  font-size: 12px;
  opacity: 0.8;
  line-height: 1;
}

/* OPCIONES DE REGALO */
.opciones-regalo {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 380px;
  margin: 0 auto 32px;
}

.opcion-card {
  backdrop-filter: blur(4px);
  border-radius: 12px;
  padding: 16px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icono-opcion {
  width: 65px;
  height: auto;
  margin-bottom: 8px;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,.1));
}

.icono-placeholder {
  font-size: 32px;
  margin-bottom: 8px;
}

.opcion-card h3 {
  font-family: 'britishgruesa', serif;
  font-size: 39px !important;
  margin: 0 0 4px;
  letter-spacing: 0.05em;
}

.opcion-card p {
  font-family: 'quote', serif;
  font-size: 20px;
  margin: 0;
  opacity: 0.9;
}

.opcion-card .destinatario {
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 2px;
}

.opcion-card .detalle-zelle {
  font-size: 23px;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 10px;
  border-radius: 20px;
  margin-top: 4px;
}

/* GRACIAS */
.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  letter-spacing: .08em;
  color: #fff;
  font-weight: 800;
  margin-top: 20px;
}

/* LLUVIA */
.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.sobre-lluvia{
  position: absolute;
  width: 28px;
  top: -10%;
  opacity: .9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.1));
}

/* CLASE INICIAL PARA ANIMACIÓN CON GSAP */
.a-animar {
  opacity: 0;
}
</style>